import api from '../../api';

// === Announcements ===
export const getAnnouncements = async () => {
    try {
        const response = await api.get('/updates/Announcement');
        return response.data;
    } catch (error) {
        console.error('Error fetching announcements:', error);
        return [];
    }
};

export const addAnnouncement = async (data) => {
    try {
        const response = await api.post('/updates', { ...data, type: 'Announcement' });
        return response.data;
    } catch (error) {
        console.error('Error adding announcement:', error);
        throw error;
    }
};

export const deleteAnnouncement = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting announcement:', error);
        throw error;
    }
};

// === Important Dates ===
export const getImportantDates = async () => {
    try {
        const response = await api.get('/updates/ImportantDate');
        return response.data;
    } catch (error) {
        console.error('Error fetching important dates:', error);
        return [];
    }
};

export const addImportantDate = async (data) => {
    try {
        const response = await api.post('/updates', { ...data, type: 'ImportantDate' });
        return response.data;
    } catch (error) {
        console.error('Error adding important date:', error);
        throw error;
    }
};

export const deleteImportantDate = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting important date:', error);
        throw error;
    }
};

// === Latest News ===
export const getLatestNews = async () => {
    try {
        const response = await api.get('/updates/News');
        return response.data;
    } catch (error) {
        console.error('Error fetching news:', error);
        return [];
    }
};

export const addNews = async (data) => {
    try {
        const response = await api.post('/updates', { ...data, type: 'News' });
        return response.data;
    } catch (error) {
        console.error('Error adding news:', error);
        throw error;
    }
};

export const deleteNews = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting news:', error);
        throw error;
    }
};

// === Update existing entry (optional) ===
export const updateItem = async (id, data) => {
    try {
        const response = await api.put(`/updates/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating item:', error);
        throw error;
    }
};

export const getHighlights = async () => {
    try {
        const response = await api.get('Updates/Highlight');
        return response.data;
    } catch (error) {
        console.error('Error fetching highlights:', error);
        return [];
    }
};

export const addHighlight = async (data) => {
    try {
        const response = await api.post('/Updates', { ...data, type: 'Highlight' });
        console.log("Update Highlight Response ", response)
        return response.data;
    } catch (error) {
        console.error('Error adding highlight:', error);
        throw error;
    }
};

export const deleteHighlight = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting highlight:', error);
        throw error;
    }
};


// -------------------------
// Employee Spotlight
// -------------------------
export const getSpotlight = async () => {
    try {
        const response = await api.get('/updates/Spotlight');
        return response.data;
    } catch (error) {
        console.error('Error fetching spotlight:', error);
        return [];
    }
};

export const addSpotlight = async (data) => {
    try {
        const response = await api.post('/updates', { ...data, type: 'Spotlight' });
        return response.data;
    } catch (error) {
        console.error('Error adding spotlight:', error);
        throw error;
    }
};

export const deleteSpotlight = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting spotlight:', error);
        throw error;
    }
};


// -------------------------
// Upcoming Events
// -------------------------
export const getEvents = async () => {
    try {
        const response = await api.get('/updates/Event');
        return response.data;
    } catch (error) {
        console.error('Error fetching events:', error);
        return [];
    }
};

export const addEvent = async (data) => {
    try {
        const response = await api.post('/updates', { ...data, type: 'Event' });
        return response.data;
    } catch (error) {
        console.error('Error adding event:', error);
        throw error;
    }
};

export const deleteEvent = async (id) => {
    try {
        await api.delete(`/updates/${id}`);
    } catch (error) {
        console.error('Error deleting event:', error);
        throw error;
    }
};


export const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/upload/image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data.imageUrl; // now returns "/uploads/filename.jpg"
};